import { render, staticRenderFns } from "./ScreeningDocumentTrackItemEdit.vue?vue&type=template&id=6479ecb6"
import script from "./ScreeningDocumentTrackItemEdit.vue?vue&type=script&lang=ts"
export * from "./ScreeningDocumentTrackItemEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports